// Folds spelling variants so "Health & PE" == "Health And PE" and
// "Chapter 1: A Letter to God" == "A Letter to God" (mirrors the backend).
export const nameKey = (s) => (s || '')
  .normalize('NFKC').trim().toLowerCase()
  .replace(/^(?:chapter|ch|unit|lesson|l)\s*[-.]?\s*\d+\s*[:.\-–)]\s*/i, '')
  .replace(/&/g, ' and ')
  .replace(/[^a-z0-9 ]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

export const sameName = (a, b) => nameKey(a) === nameKey(b);
